import { NotifyModel, NotifyModelProps } from '@mail/3promo';
import { ReactRenderer } from '@mail/3promo/render/react';
import { LocalStorageStore } from '@mail/3promo/stores/localStorage';
import type { ModelCreator } from '@mail/3promo/types';
import { webpushConfig } from 'reactApp/appHelpers/featuresHelpers/features/webPush';
import { safetyPersonalLocalStorage } from 'reactApp/storage';
import { sendDwh } from 'reactApp/utils/ga';
import { EPaymentGa } from 'reactApp/utils/paymentGa';

import { type WebPushTemplateData, WebPushNotifyPromo } from '../components/WebPush/WebPushNotifyPromo';
import { MS_IN_DAY, WEB_PUSH_PROMO_CLOSED_UNTIL_KEY as CLOSED_UNTIL_KEY, WEB_PUSH_PROMO_ID as PROMO_ID } from './webPushPromoStatus';

const { intervalAfterCloseDays, intervalAfterSnoozeDays, showLimit, closeLimit } = webpushConfig.notifyRequestConfig;

export const webPushTooltipCreator: ModelCreator = ({ models, render, stores }) => {
    return new NotifyModel(
        PROMO_ID,
        { ...models.base, ...models.notify },
        new NotifyModelProps<WebPushTemplateData>(PROMO_ID, {
            store: new LocalStorageStore(PROMO_ID, stores.localStorage),
            renderer: new ReactRenderer(PROMO_ID, WebPushNotifyPromo as any, render.react),
            closable: true,
            hideOnCompleted: true,
            hideOnSnooze: true,
            ignorePromoShowInterval: true,
            showLimit,
            closeLimit,
            templateData: {},
            test(resolve, reject) {
                if (typeof Notification === 'undefined') {
                    reject();
                    return;
                }

                if (Notification.permission !== 'default') {
                    reject();
                    return;
                }

                if (!window.__WP?.requestPermission) {
                    reject();
                    return;
                }

                const closedUntil = safetyPersonalLocalStorage.getItem(CLOSED_UNTIL_KEY);

                if (closedUntil && Date.now() < Number(closedUntil)) {
                    reject();
                    return;
                }

                resolve();
            },
            onShow() {
                sendDwh({ eventCategory: EPaymentGa.webPush, action: 'promo-tooltip-show' });
            },
            onClose() {
                sendDwh({ eventCategory: EPaymentGa.webPush, action: 'promo-tooltip-close' });
                safetyPersonalLocalStorage.setItem(CLOSED_UNTIL_KEY, String(Date.now() + intervalAfterCloseDays * MS_IN_DAY));
            },
            onComplete() {
                sendDwh({ eventCategory: EPaymentGa.webPush, action: 'promo-tooltip-click' });
            },
            onSnooze() {
                sendDwh({ eventCategory: EPaymentGa.webPush, action: 'promo-tooltip-postpone' });
                safetyPersonalLocalStorage.setItem(CLOSED_UNTIL_KEY, String(Date.now() + intervalAfterSnoozeDays * MS_IN_DAY));
            },
        })
    );
};
